import styled from 'styled-components/native';

export default styled.View<{ isProcessing: boolean }>`
  margin-left: 8px;
  opacity: ${({ isProcessing }) => (isProcessing ? '0.5' : '1')};
  flex: 1;
`;
